import { useSearchParams } from 'react-router-dom';
import { ProfileTab } from '../components/account/ProfileTab.tsx';
import { SecurityTab } from '../components/account/SecurityTab.tsx';
import { StorageTab } from '../components/account/StorageTab.tsx';
import { NotificationsTab } from '../components/account/NotificationsTab.tsx';
import { DriveTab } from '../components/account/DriveTab.tsx';

const TABS = [
  { key: 'profile', label: '프로필' },
  { key: 'security', label: '보안' },
  { key: 'storage', label: '저장 공간' },
  { key: 'drive', label: '네트워크 드라이브' },
  { key: 'notifications', label: '알림' },
] as const;

type TabKey = (typeof TABS)[number]['key'];

/** 탭을 쿼리스트링에 두어 새로고침·뒤로가기가 자연스럽게 동작하게 한다. */
export function AccountPage() {
  const [params, setParams] = useSearchParams();
  const raw = params.get('tab') ?? 'profile';
  const tab: TabKey = TABS.some((t) => t.key === raw) ? (raw as TabKey) : 'profile';

  return (
    <div className="page">
      <div className="page__head">
        <h1 className="page__title">내 계정</h1>
        <div className="drawer__tabs" style={{ padding: 0 }} role="tablist">
          {TABS.map((t) => (
            <button
              key={t.key}
              className="drawer__tab"
              data-active={tab === t.key}
              role="tab"
              aria-selected={tab === t.key}
              onClick={() => { setParams({ tab: t.key }); }}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="page__body" style={{ padding: 'var(--sp-5)' }}>
        {tab === 'profile' && <ProfileTab />}
        {tab === 'security' && <SecurityTab />}
        {tab === 'storage' && <StorageTab />}
        {tab === 'drive' && <DriveTab />}
        {tab === 'notifications' && <NotificationsTab />}
      </div>
    </div>
  );
}
